import { Component, OnDestroy, OnInit } from '@angular/core';
import { GetLogFilesRepository } from '../Get-Log-Files/getLogFiles.repository';
import { GetLogFileService } from '../Get-Log-Files/getLogFile.service';
import { BusyIndicatorService, IBusyIndicatorConfig, SnackBarService } from 'src/app/Busy-Indicator';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { LongRunningProcessService } from 'src/app/Compliance/Long-Running-Process/longRunningProcess.service';

@Component({
    selector: 'get-log-files',
    templateUrl: './getLogFiles.component.html',
    styleUrls: ['./getLogFiles.component.scss'],
    standalone: false,
})
export class GetLogFilesComponent implements OnInit, OnDestroy {
    constructor(
        private readonly getLogFilesRepository: GetLogFilesRepository,
        private readonly _busyIndicatorService: BusyIndicatorService,
        private readonly _snackBarService: SnackBarService,
        private readonly _getLogFilesService: GetLogFileService,
        private readonly _longRunningProcessService: LongRunningProcessService,
    ) {}

    selectedLocation: Core.LogFileLocationViewModel;
    LogFileLocationList: Core.LogFileLocationViewModel[];
    fileList: Core.LogFileViewModel[];
      private destroy$: Subject<void> = new Subject();

    ngOnInit(): void {
        this.selectedLocation = null;
        this.getLogfileLocationList();
    }

        ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }

    locationChanged() {
         this.getLogfileList();
    }

    async getLogfileLocationList() {
        const result = await this._getLogFilesService.getLogfileLocationList();
        this.LogFileLocationList = result;
    }

    async getLogfileList() {
      
        const longRunningProcessId = await this._getLogFilesService.getLogFileList(this.selectedLocation);
        this._getLRPResult(longRunningProcessId, 'Get Log File List', 'Getting Log File List');
    }

    private async _getLRPResult(longRunningProcessId: number, title: string, message: string): Promise<void> {
        const identifier = this._busyIndicatorService.generateUniqueMessageIdentifier();

            const busyConfig: IBusyIndicatorConfig = {
                   identifier,
                   longRunningProcessId,
                   title,
                   message,
                   hasProgressBar: false
               };
        
            const busyRef = this._busyIndicatorService.show(busyConfig);

            busyRef.onProgressBarComplete().pipe(takeUntil(this.destroy$)).subscribe(async (succeeded: boolean) => {
            busyRef.hide();

            if (succeeded) {
                 const longRunningProcesResult = await this._longRunningProcessService.get(longRunningProcessId);
                 const result : Core.LogFileResultModel = JSON.parse(longRunningProcesResult.result);
                if (result) 
                    this.fileList = result.returnResult;
                }
            else
                {   this.fileList = [];
                    this.fileList.length = 0;}   

            this.destroy$.next();
        });
         
            busyRef.onDismiss().pipe(takeUntil(this.destroy$)).subscribe(() => {
            busyRef.hide();
            this.destroy$.next();
        });
    
    }

    async downloadLogFile(file: Core.LogFileViewModel) {
        const busyRef = this._busyIndicatorService.show({ message: 'Downloading...' });

        try {
            const longRunningProcessId = await this._getLogFilesService.downloadLogFile(file);
            this._snackBarService.addById(longRunningProcessId, Compliance.LongRunningProcessTypeEnum.DownloadLogFile);
        } finally {
            busyRef.hide();
        }
    }
}
